import Vue from 'vue';
import App from './App.vue';
import router from './router';
Vue.config.productionTip = false;
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'mGOZSKVAhwHWN9glQunKXeMdWIdVe2LQ'
})

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
